import { render, staticRenderFns } from "./IconLecture.vue?vue&type=template&id=483f6066"
import script from "./IconLecture.vue?vue&type=script&lang=ts"
export * from "./IconLecture.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports